<template>
<div class="chapter">
<div class="inner_page">
<p class="P_x-2-chapter-title_para-style-override-10__And__Centre_Alignment"><span><b>Contents</b></span></p>
<p class="P_Basic-Paragraph"> </p>
<p class="P_Basic-Paragraph"><a href="#/section0005">Prologue</a></p>
<p class="P_Basic-Paragraph"> </p>
<p class="P_Basic-Paragraph"><a href="#/section0007">Chapter 1</a>      Lighting the Way</p>
<p class="P_Basic-Paragraph"> </p>
<p class="P_Basic-Paragraph"><a href="#/section0008">Chapter 2</a>      Legends of the First People</p>
<p class="P_Basic-Paragraph"> </p>
<p class="P_Basic-Paragraph"><span href="#/section0009" title="Link target outside of Sample">Chapter 3</span>      All in a Day’s Catch</p>
<p class="P_Basic-Paragraph"> </p>
<p class="P_Basic-Paragraph"><span href="#/section0010" title="Link target outside of Sample">Chapter 4</span>      Crossing the Finish Line</p>
<p class="P_Basic-Paragraph"> </p>
<p class="P_Basic-Paragraph"><span href="#/section0011" title="Link target outside of Sample">Chapter 5</span>      Beauvoir, a Complicated History</p>
<p class="P_Basic-Paragraph"> </p>
<p class="P_Basic-Paragraph"><span href="#/section0012" title="Link target outside of Sample">Chapter 6</span>      Queen of the Watering Places</p>
<p class="P_Basic-Paragraph"> </p>
<p class="P_Basic-Paragraph"><span href="#/section0013" title="Link target outside of Sample">Chapter 7</span>      The Crown Jewel</p>
<p class="P_Basic-Paragraph"> </p>
<p class="P_Basic-Paragraph"><span href="#/section0014" title="Link target outside of Sample">Chapter 8</span>      Biloxi’s Hermit</p>
<p class="P_Basic-Paragraph"> </p>
<p class="P_Basic-Paragraph"><span href="#/section0015" title="Link target outside of Sample">Chapter 9</span>      Fantasy Island</p>
<p class="P_Basic-Paragraph"> </p>
<p class="P_Basic-Paragraph"><span href="#/section0016" title="Link target outside of Sample">Chapter 10</span>    The Mad Potter</p>
<p class="P_Basic-Paragraph"> </p>
<p class="P_Basic-Paragraph"><span href="#/section0017" title="Link target outside of Sample">Chapter 11</span>    The Root Beer Wizard</p>
<p class="P_Basic-Paragraph"> </p>
<p class="P_Basic-Paragraph"><span href="#/section0018" title="Link target outside of Sample">Chapter 12</span>    Gus, Elvis, and Jayne</p>
<p class="P_Basic-Paragraph"> </p>
<p class="P_Basic-Paragraph"><span href="#/section0019" title="Link target outside of Sample">Chapter 13</span>    Keep ’em Flying</p>
<p class="P_Basic-Paragraph"> </p>
<p class="P_Basic-Paragraph"><span href="#/section0020" title="Link target outside of Sample">Chapter 14</span>    Mary’s Legacy</p>
<p class="P_Basic-Paragraph"> </p>
<p class="P_Basic-Paragraph"><span href="#/section0021" title="Link target outside of Sample">Chapter 15</span>    Motels, Eateries, and Attractions</p>
<p class="P_Basic-Paragraph"> </p>
<p class="P_Basic-Paragraph"><span href="#/section0022" title="Link target outside of Sample">Chapter 16</span>    Sand, Surf, and Struggle</p>
<p class="P_Basic-Paragraph"> </p>
<p class="P_Basic-Paragraph"><span href="#/section0023" title="Link target outside of Sample">Chapter 17</span>    Mother Nature Unleashed</p>
<p class="P_Basic-Paragraph"> </p>
<p class="P_Basic-Paragraph"><span href="#/section0024" title="Link target outside of Sample">Chapter 18</span>    Iberville, Ixolib, and Vintage Cars</p>
<p class="P_Basic-Paragraph"> </p>
<p class="P_Basic-Paragraph"><span href="#/section0025" title="Link target outside of Sample">Chapter 19</span>    Place Your Bets</p>
<p class="P_Basic-Paragraph"> </p>
<p class="P_Basic-Paragraph"><span href="#/section0026" title="Link target outside of Sample">Chapter 20</span>    Cultural Connections</p>
<p class="P_Basic-Paragraph"> </p>
<p class="P_Basic-Paragraph"><span href="#/section0027" title="Link target outside of Sample">Epilogue</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0004.vue?589d49b9